export var hexToRgb = function hexToRgb(e) {
  var t = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(e);
  return t ? {
    r: parseInt(t[1], 16),
    g: parseInt(t[2], 16),
    b: parseInt(t[3], 16)
  } : null;
};
export var generateKey = function generateKey() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;
  return Math.random().toString(16).substr(2, e);
};
export var handleAccessibleKeyPress = function handleAccessibleKeyPress(e, t) {
  "click" !== e.type && "Enter" !== e.key && " " !== e.key && "Spacebar" !== e.key || t();
};